// THIS CODE WAS AUTO-GENERATED from '/packages/icon/icons/makeSvgsIntoJsx.js'
// PLEASE DO NOT EDIT HERE. EDIT THE FILE THAT MADE THIS
import React from 'react'
import { sanitizeProps } from '@fs/zion-frontend-friends'
import { BaseIcon, type IconProps } from '../BaseIcon'

export default (props: IconProps): JSX.Element => (
  <BaseIcon {...sanitizeProps(props)}>
    <path d="m20.44 21.6-7-7a6.7 6.7 0 0 1-4.22 1.45q-3.03 0-5.12-2.1C2 11.86 2 10.86 2 8.84s.7-3.73 2.1-5.12 3.1-2.1 5.12-2.1 3.73.7 5.13 2.1 2.1 3.1 2.1 5.12A6.8 6.8 0 0 1 15 13.05l7 7zM9.22 14.34q2.3 0 3.9-1.6c1.6-1.6 1.6-2.37 1.6-3.9s-.53-2.83-1.6-3.9-2.37-1.6-3.9-1.6-2.82.54-3.9 1.6-1.6 2.37-1.6 3.9.54 2.83 1.6 3.9 2.37 1.6 3.9 1.6" />
  </BaseIcon>
)
